import { combineReducers } from 'redux';
// react-router-redux is no longer needed with React Router v6
// import { routerReducer } from 'react-router-redux';
import { reducer as formReducer } from 'redux-form';
import pageBase from '../components/layouts/PageBase/reducer';
import login from '../pages/Login/reducer';
import forgotPassword from '../pages/ForgotPassword/reducer';
import resetPassword from '../pages/ResetPassword/reducer';
import home from '../pages/Home/reducer';
import stock from '../pages/Stock/reducer';
import prices from '../pages/SettingHarga/reducer';
import merchantRegistrations from '../pages/RegistrasiMerchant/reducer';
import faq from '../pages/Faq/reducer';
import manualLoggingActivation from '../pages/AktivasiPencatatanManual/reducer';
// import verificationRegistrationMerchant from '../pages/VerificationRegistrationMerchant/reducer';
import user from '../pages/User/reducer';
import role from '../pages/Role/reducer';
import permission from '../pages/Permission/reducer';
import merchantVerification from '../pages/VerificationRegistrationMerchant/reducer';
import merchantSetting from '../pages/SettingMerchant/reducer';
import auditLog from '../pages/AuditLog/reducer';
import myptmActivation from '../pages/AktivasiMyPertamina/reducer';
import termCondition from '../pages/TermCondition/reducer';
import notification from '../pages/Notification/reducer';
import logsSyncMerchant from '../pages/SinkronisasiMerchant/reducer';
import updateStockMerchant from '../pages/UpdateStockMerchant/reducer';
import scanCodeMfa from '../pages/MfaScanCode/reducer';
import mfa from '../pages/Mfa/reducer';
import merchantNotOnboard from '../pages/MerchantNotOnboarding/reducer';
import profile from '../pages/Profile/reducer';
import setupAuthenticator from '../pages/SetupAuthenticator/reducer';
import settingBusinessType from '../pages/SettingBusinessType/reducer';
import subMerchantAggregate from '../pages/SubMerchantAggregate/reducer';
import settingSubMerchant from '../pages/SettingSubMerchant/reducer';
import subMerchantActivation from '../pages/SubMerchantActivation/reducer';
import areaManagement from '../pages/AreaManagement/reducer';
import nikManagement from '../pages/NikManagement/reducer';
import provinceTransactionRestriction from '../pages/ProvinceTransactionRestriction/reducer';
import settingReasonBlockId from '../pages/SettingReasonBlockId/reducer';
import gigrActivation from '../pages/GIGRActivation/reducer';
import customerSubmissionUnblock from '../pages/CustomerSubmissionUnblock/reducer';
import historyLog from '../components/elements/HistoryLog/reducer';
import mapFeatureActivation from '../pages/MAPFeatureActivation/reducer';
import informasiBesaranSubsidi from '../pages/InformasiBesaranSubsidi/reducer';

const rootReducer = combineReducers({
  form: formReducer,
  login,
  forgotPassword,
  resetPassword,
  home,
  stock,
  pageBase,
  prices,
  merchantRegistrations,
  // routing: routerReducer - removed (React Router v6 doesn't need Redux sync)
  manualLoggingActivation,
  faq,
  user,
  role,
  permission,
  merchantVerification,
  merchantSetting,
  auditLog,
  myptmActivation,
  termCondition,
  notification,
  logsSyncMerchant,
  updateStockMerchant,
  scanCodeMfa,
  mfa,
  merchantNotOnboard,
  profile,
  setupAuthenticator,
  settingBusinessType,
  subMerchantAggregate,
  settingSubMerchant,
  subMerchantActivation,
  areaManagement,
  nikManagement,
  provinceTransactionRestriction,
  settingReasonBlockId,
  gigrActivation,
  customerSubmissionUnblock,
  historyLog,
  mapFeatureActivation,
  informasiBesaranSubsidi,
  // routing: routerReducer - no longer needed with React Router v6
});

export default rootReducer;
